export default {
  props: {
    value: String,
    id: String,
    fieldValue: { type: String, default: 'code' },
    fieldLabel: { type: String, default: 'name' },
    readonly: { type: Boolean, default: true },
    highlight: { type: Boolean, default: true },
    disabled: Boolean,
    clearable: { type: Boolean, default: true }
  }
}
